import { useContext } from "react";
import VenueContext from "@/context/Venue";

const Venue = () => {
  const context = useContext(VenueContext);

  return context;
};

export { Venue as useVenue };
